import { Box, Button, Container, Grid, Paper, TextField, Alert, Collapse, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { InterInstance } from '@api/config';
import { getToken } from '@api/getToken';
import { useHistory } from 'react-router-dom';
import { useAsociadoStore } from '@store/useAsociadoStore';
import { useTokenStore } from '@store/TokenStore';
import { useIdStore } from '@store/UrlIdStore';
import { ZustandContext } from '@store/modalStore';
import { UnRegisteredContributorModal } from '@modals/UnRegisteredContributorModal';


const FormValidarUsuario = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const history = useHistory();
  const { guardarDatos, marcarVerificado } = useAsociadoStore();
  const { token } = useTokenStore();
  const { id, setId } = useIdStore();
  const { show, hide } = React.useContext(ZustandContext);

  const handleLimitReached = () => {
    show(UnRegisteredContributorModal, { onClose: hide });
  };

  const validationSchema = Yup.object({
    colaborador: Yup.string().required('El número de colaborador es requerido'),
    /*email: Yup.string()
      .email('El correo electrónico no es válido')
      .required('El correo electrónico es requerido'),*/
  });

  const formik = useFormik({
    initialValues: {
      colaborador: '',
      //email: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      setError(null);
      try {
        //const token = await getToken();
        let tmpToken = token || (await getToken());
       /* const response = await InterInstance({
          method: 'GET',
          url: `/catalogs/coppel-workers/buscar/${values.colaborador}/${values.email}`,
          headers: { Authorization: `Bearer ${tmpToken}` },
        }).catch((error) => {
          console.error('Error de conexión:', JSON.stringify(error));
          return error.response;
        });*/
        const response = await InterInstance.get(
          // `/catalogs/coppel-workers/buscar/${values.colaborador}/${values.email}`,
          `/catalogs/coppel-workers/envianotificacion/${values.colaborador}`,
          {
            headers: { Authorization: `Bearer ${tmpToken}` },
          }
        );
        //.log('Respuesta del API:', response);
        if (response?.data && response.data.success && response.data.allowed) {
         // console.log('data==>>>', response.data.data)
              const responseData = {
                ...response.data.data,
                numColaborador: values.colaborador,
              };
          await guardarDatos(responseData);
          await setId(values.colaborador);
         await marcarVerificado(true);

        } else {
          setError('El número de colaborador o el correo electrónico no son válidos.');
        }
      } catch (error) {
        //setError('Ocurrió un error al validar el usuario. Por favor, inténtalo de nuevo.');
        handleLimitReached()
        console.error('Error al validar el usuario:', error);
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <>
      <Box sx={{ py: { xs: 6, md: 25 } }}>
        <Container maxWidth="lg">
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: '16px',
                border: '1px solid #EAEAEA',
                boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                backgroundColor: '#FFFFFF',
                width: { xs: '285px', md: '410px' },
              }}
            >
              <Typography sx={{ fontSize: { xs: '20px', md: '30px' }, fontWeight: 700 }}>
                Bienvenido de nuevo
              </Typography>
              <Typography sx={{ fontSize: { xs: '12px', md: '18px' }, mb:'15px' }}>
                Por favor, introduzca sus datos
              </Typography>
              <form onSubmit={formik.handleSubmit}>
                <Stack spacing={2.5} sx={{ width: '100%' }}>
                  {/*<Collapse in={!!error}>*/}
                  {/*  <Alert*/}
                  {/*    severity="error"*/}
                  {/*    onClose={() => setError(null)}*/}
                  {/*    sx={{ mb: 2 }}*/}
                  {/*  >*/}
                  {/*    {error}*/}
                  {/*  </Alert>*/}
                  {/*</Collapse>*/}
                  <TextField
                    fullWidth
                    size="small"
                    id="colaborador"
                    name="colaborador"
                    label="Número de colaborador"
                    value={formik.values.colaborador}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.colaborador &&
                      Boolean(formik.errors.colaborador)
                    }
                    helperText={
                      formik.touched.colaborador && formik.errors.colaborador
                    }
                  />
                 {/* <TextField
                    fullWidth
                    size="small"
                    id="email"
                    name="email"
                    label="Correo Electrónico"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />*/}

                  <Button
                    fullWidth
                    variant="contained"
                    type="submit"
                    disabled={isLoading} // Deshabilitar el botón durante la carga
                    sx={{
                      backgroundColor: '#00A9E0',
                      color: '#041658',
                      fontWeight: 700,
                      textTransform: 'none',
                      borderRadius: '50px',
                      py: 1.2,
                      mt: 1,
                      boxShadow: 'none',
                      '&:hover': {
                        backgroundColor: '#008bb8',
                        boxShadow: 'none',
                      },
                    }}
                  >
                    {isLoading ? 'Validando...' : 'Validar'}
                  </Button>
                </Stack>
              </form>
            </Paper>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default FormValidarUsuario;
